<script>
  import router from '../../../lib/router';
  import APIClient from '../../../state-charts/api-client';
  import Dialog from '../../../lib/components/Dialog.svelte';
  import { t9n } from '../../../lib/translate.js';
  import { TS } from '../../../config/translation-keys.js';
  import { show_message } from '../../../lib/flash';
  import session from '../../../lib/session';
  import { format_date, format_multiple_dates, parse_time_value } from '../../../lib/utils';
  import moment from 'moment';
  import { show_tutorial_screen } from '../../../lib/tutorials';

  // component options  ------------------------------------------------------ //

  export let task_description;
  export let payment_items;
  export let additional_info;
  export let public_teams;
  export let category_name;
  export let time;
  export let category_selector;
  export let amount;
  export let location;
  export let worker_email;
  export let primary_address;
  export let secondary_address;
  export let city;
  export let region;
  export let postal_code;
  export let longitude;
  export let latitude;
  export let private_team_id;
  export let private_team_name;
  export let is_virtual = false;
  export let page_state;
  export let order_uuid;
  export let order;
  export let acc_ref;
  export let url_units;
  export let teamcode;
  export let no_payment;
  export let url_no_payment;
  export let additional_fields;
  export let start_date;
  export let end_date;
  export let start_time;
  export let end_time;

  export let show_nets;
  export let transaction_id;
  export let reserve_uuid;
  export let post_order;
  export let orderer_amount;

  // internal variables ------------------------------------------------------ //

  let api_json_with_apps = {
    additional_info: null,
    order_uuid: null,
    payment: {
      credit_card_id: 0,
      payment_type: 'payment_type_billing',
    },
  };

  let api_json = {
    details: {
      additional_info: '',
      address: {
        city: '',
        latitude: 0,
        longitude: 0,
        postal_code: '',
        primary_address: '',
        region: '',
        secondary_address: '',
        is_virtual: false,
      },
      description: '',
      duration: 0,
      teams: {
        private: [],
        public: [],
      },
      worker_email: '',
    },
    payment: {
      credit_card_id: 0,
      payment_type: '',
    },
    product: {
      product_id: 0,
    },
  };

  let table_data;
  let orderer_price;
  let vat;
  let sum_task_desc;
  let sum_time;
  let sum_additional = null;
  let payment_options;
  let wait_api = false;

  //transkeys

  let neworder;
  let publish;
  let taskdesc;
  let type;
  let teams;
  let privteam;
  let tableamount;
  let payment;
  let price;
  let tablevat;
  let total;
  let tableaddinfo;
  let tableloc;
  let tabletime;
  let cancel;
  let yes;
  let btn_prev;
  let btn_publish;
  let workeremail;
  let distancework;

  // utility functions -------------------------------------------------------- //


  const get_price = () => {
    let products = $session.merchant.products;
    for (let i = 0; i < products.length; i++) {
      if (products[i].product_id === category_selector) {
        orderer_price = products[i].orderer_price;
      }
    }
    orderer_price *= amount;
    return orderer_price.toFixed(2) + ' ' + $session.merchant.currency_sign;
  };

  const get_vat = () => {
    for (let i = 0; i < $session.merchant.products.length; i++) {
      if ($session.merchant.products[i].product_id === category_selector) {
        vat = $session.merchant.products[i].orderer_vat_amount * amount;
        return vat.toFixed(2) + ' ' + $session.merchant.currency_sign;
      }
    }
  };

  const get_price_without_vat = () => {
    let products = $session.merchant.products;
    for (let i = 0; i < products.length; i++) {
      if (products[i].product_id === category_selector) {
        orderer_price = products[i].orderer_price;
      }
    }

    for (let i = 0; i < $session.merchant.products.length; i++) {
      if ($session.merchant.products[i].product_id === category_selector) {
        vat = $session.merchant.products[i].orderer_vat_amount * amount;
      }
    }
    orderer_price *= amount;
    return (
            (orderer_price - vat).toFixed(2) + ' ' + $session.merchant.currency_sign
    );
  };

  const to_moment = date => {
    return date.replace('Z', '0000');
  };

  const reset_api_json = () => {
    api_json = {
      details: {
        additional_info: '',
        address: {
          city: '',
          latitude: 0,
          longitude: 0,
          postal_code: '',
          primary_address: '',
          region: '',
          secondary_address: '',
          is_virtual: false,
        },
        description: '',
        duration: 0,
        teams: {
          private: [],
          public: [],
        },
        worker_email: '',
      },
      payment: {
        credit_card_id: 0,
        payment_type: '',
      },
      product: {
        product_id: 0,
      },
    };
  }
  const create_api_json = () => {
    reset_api_json();
    if (!!order && order.applications.length > 0 && page_state === 'edit') {
      api_json_with_apps.additional_info = additional_info;
      api_json_with_apps.order_uuid = order_uuid;
      api_json_with_apps.payment.credit_card_id = get_credit_card_id();
      api_json_with_apps.payment.payment_type = get_payment_type();
    } else {
      if (additional_info === null) {
        api_json.details.additional_info = '';
      } else {
        api_json.details.additional_info = additional_info;
      }
      if (!!time) {
        api_json.details.initial_order_time = time;


      } else {
        if (!!start_time) {
          api_json.details.initial_start_has_time = true;
          api_json.details.initial_start_date = new Date(`${start_date}T${start_time}`).toISOString()

        } else {
          api_json.details.initial_start_has_time = false;
          api_json.details.initial_start_date = new Date(`${start_date}T00:00`).toISOString()
        }

        if (!!end_time) {
          api_json.details.initial_end_has_time = true;

          if (!!end_date) {
            api_json.details.initial_end_date = new Date(`${end_date}T${end_time}`).toISOString()
          } else {
            api_json.details.initial_end_date = new Date(`${start_date}T${end_time}`).toISOString()
          }
        } else {
          api_json.details.initial_end_has_time = false;
          if (!!end_date) {
            api_json.details.initial_end_date = new Date(`${end_date}T00:00`).toISOString()
          }
        }
      }
      api_json.details.description = task_description;
      api_json.details.duration = amount;
      api_json.details.teams.public = get_public_teams();
      api_json.details.account_reference = acc_ref;
      let private_array = [];
      if (private_team_id !== null && private_team_name !== null && teamcode.length > 0) {
        private_array.push(private_team_id);
      }

      if(private_array.length > 0){
        api_json.details.teams.private = private_array;
      }

      api_json.details.worker_email = worker_email;

      api_json.payment.credit_card_id = get_credit_card_id();
      api_json.payment.payment_type = get_payment_type();
      api_json.product.product_id = category_selector;
      api_json.details.address.is_virtual = is_virtual;

      if (!is_virtual) {
        api_json.details.address.city = city;
        api_json.details.address.latitude = latitude;
        api_json.details.address.longitude = longitude;
        api_json.details.address.postal_code = postal_code;
        api_json.details.address.primary_address = primary_address;
        api_json.details.address.region = region;
        api_json.details.address.secondary_address = secondary_address;
      } else {
        api_json.details.address.city = $session.user.address.city;
        api_json.details.address.latitude = $session.user.address.latitude;
        api_json.details.address.longitude = $session.user.address.longitude;
        api_json.details.address.postal_code =
                $session.user.address.postal_code;
        api_json.details.address.primary_address =
                $session.user.address.primary_address;
        api_json.details.address.region = $session.user.address.region;
        api_json.details.address.secondary_address =
                $session.user.address.secondary_address;
      }

      if(!api_json.details.address.postal_code) api_json.details.address.postal_code = "00000";

      if (page_state === 'edit') {
        api_json.order_uuid = order_uuid;
      }

      if (no_payment || url_no_payment) {
        api_json.payment.payment_type = 'payment_type_no_payment';
      }

      if (!!reserve_uuid && post_order) {
        api_json.payment.reserve_uuid = reserve_uuid;
      }

      if (!!additional_fields) {
        let tmp_fields = [];
        additional_fields.forEach(e => {
          if (!!e.value) {
            tmp_fields.push({
              id: e.id,
              value: e.value,
            });
          }
        });

        api_json.details.additional_fields = tmp_fields;
      }
    }
  };

  const get_payment_type = () => {
    for (let i = 0; i < payment_items.length; i++) {
      if (payment_items[i].is_selected === true) {

        return payment_items[i].payment_type;
      }
    }
  };

  const get_credit_card_id = () => {
    for (let i = 0; i < payment_items.length; i++) {
      if (payment_items[i].is_selected === true) {
        if (payment_items[i].payment_type === 'payment_type_credit_card') {
          let tmp_id = payment_items[i].credit_card_id;
          return tmp_id;
        } else {
          return 0;
        }
      }
    }
  };

  const get_public_teams = () => {
    let teams = [];
    for (let i = 0; i < public_teams.length; i++) {
      if (public_teams[i].selected === true)
        teams.push(public_teams[i].team_id);
    }
    return teams;
  };

  const format_teams_string = () => {
    let tmp_string = '';
    let has_any_selected = false;
    for (let i = 0; i < public_teams.length; i++) {
      if (public_teams[i].selected === true) {
        has_any_selected = true;
        if (i === 0) tmp_string += public_teams[i].name;
        if (i > 0) tmp_string += '\n' + public_teams[i].name;
      }
    }
    if (!!table_data) {
      if (has_any_selected === true) {
        table_data[3].right = tmp_string;
      } else {
        table_data[3].right = null;
      }
    }
  };

  const call_api = async () => {
    let result;
    wait_api = true;
    if (page_state === 'edit') {
      if (order.applications.length === 0) {
        result = await APIClient.edit_order(api_json);
      } else {
        result = await APIClient.edit_order_with_apps(api_json_with_apps);
      }
    } else {
        result = await APIClient.create_order(api_json);
    }


    if (!!result[0]) {
      if (!!result[0].data) {
        if (!!result[0].data.reserve_uuid) {
          orderer_amount = orderer_price;
          reserve_uuid = result[0].data.reserve_uuid;
          let data = {
            reserve_uuid: reserve_uuid,
            app: true,
          };
            const transaction_data = await APIClient.init_reserve_card(data);
            if (!!transaction_data) {
              show_nets = true;
              transaction_id = transaction_data.reference;
            }

        }
      }
    } else {
      if (result) {
        wait_api = false;
        show_message(t9n(TS.NEW_ORDER_SUCCESSFULLY_CREATED), 'success')
        router.navigate('/orders');
      }
    }
  };

  const create_switch_dialog = () => {
    let target = document.querySelector('.switch-dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'new-order-publish-dialog',
        title: neworder,
        content: publish,
        buttons: [
          {
            label: cancel,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            wait_api: wait_api,
            label: yes,
            action: async () => {
              create_api_json();
              await call_api();
              wait_api = false;
              // reserve_uuid = null;
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  let toggle_dialog = () => {
    let dialog = create_switch_dialog();
    dialog.open();
  };

  const format_location_string = () => {
    let tmp_array = [
      primary_address,
      secondary_address,
      city,
      region,
      postal_code,
    ];

    let tmp_data = '';
    for (let i = 0; i < tmp_array.length; i++) {
      if (!!tmp_array[i]) {
        if (i !== tmp_array.length - 1) {
          tmp_data += `${tmp_array[i]}, `;
        } else {
          tmp_data += tmp_array[i];
        }
      }
    }
    if (!!table_data) {
      table_data[5].right = tmp_data;
    }

    if (is_virtual) {
      table_data[5].right = t9n(TS.ORDERS_IS_VIRTUAL);
    }
  };
  const format_amount_string = () => {
    let based_on;

    for (let i = 0; i < $session.merchant.products.length; i++) {
      if ($session.merchant.products[i].product_id === category_selector) {
        based_on = $session.merchant.products[i].based_on;
      }
    }

    if (!!table_data) {
      if (based_on !== 'product_based_price') {
        if(based_on === 'product_based_hours') table_data[7].right = `${Number(amount).toFixed(2)} ${t9n(TS.LABEL_HOURS)}`;
        if(based_on === 'product_based_days') table_data[7].right = `${Number(amount).toFixed(2)} ${t9n(TS.LABEL_DAYS)}`;
        if(based_on === 'product_based_months') table_data[7].right = `${Number(amount).toFixed(2)} ${t9n(TS.LABEL_MONTHS)}`;
        if(based_on === 'product_based_units') table_data[7].right = `${Number(amount).toFixed(2)} ${t9n(TS.LABEL_UNITS)}`;
      } else {
        table_data[7].right = `${Number(amount).toFixed(2)} ${
                $session.merchant.currency_sign
        }`;
      }
    }
  };

  const format_payment_string = () => {
    for (let i = 0; i < payment_items.length; i++) {
      if (payment_items[i].is_selected === true) {
        if (!!table_data) {
          table_data[8].right = payment_items[i].name;
        }
      }
    }
  };

  const get_product_worker_type = (id) => {
    let products = $session.merchant.products;
    let product_worker_type;
    products.forEach(e => {
      if(e.product_id === id) product_worker_type = e.product_worker_type;
    });
    return t9n(product_worker_type);
  }

  // reactive functions -------------------------------------------------------- //

  $: if (post_order === true) {
    (async () => {
      create_api_json();
      await call_api();
    })();
  }
  $: sum_task_desc =
          task_description.length > 60 ? task_description : task_description;

  $: if (!!time) {
    sum_time = time.length > 60 ? time : time;
  }

  $: if (!!start_date) {
    // let start;
    // let end;
    // if(!!start_time){
    //   start = format_date(`${start_date} ${start_time}`, true);
    // } else{
    //   start = format_date(start_date);
    // }

    sum_time = format_multiple_dates(
            start_date,
            end_date,
            !!start_time,
            start_time,
            end_time,
            !end_time,
            false,
            false
    );
  }

  $: if (additional_info !== null)
    sum_additional =
            additional_info.length > 60 ? additional_info : additional_info;

  $: if (teamcode === '' || teamcode === null) {
    private_team_name = null;
  }

  $: if (orderer_price) {
    (async () => {
      await APIClient.get_payment_options_with_succ(
        { price: orderer_price },
        result => {
          payment_options = result;
        }
      );
    })();
  }

  $: if (!!table_data && payment_items) format_payment_string();
  $: if (!!table_data && public_teams) format_teams_string();
  $: if (!!table_data && amount) format_amount_string();

  const translate_texts = () => {

    table_data = [
      { left: null, right: sum_task_desc, show: true },
      { left: null, right: category_name, show: true },
      { left: null, right: sum_additional, show: true },
      { left: null, right: null, show: true },
      { left: null, right: private_team_name, show: true },

      // { left: "Worker's email address", right: worker_email},
      { left: null, right: null, show: true },
      { left: null, right: sum_time, show: true },
      { left: null, right: null, show: true },
      { left: null, right: null, show: !no_payment && !url_no_payment },
      { left: null, right: acc_ref, show: true },
      {
        left: null,
        right: get_price_without_vat(),
        show: !no_payment && !url_no_payment,
      },
      { left: null, right: get_vat(), show: !no_payment && !url_no_payment },
      { left: null, right: get_price(), show: !no_payment && !url_no_payment },
      { left: null, right: worker_email, show: true },
      { left: null, right: get_product_worker_type(category_selector), show: true},
    ];

    neworder = t9n(TS.LABEL_ORDER);
    publish = t9n(TS.NEW_ORDER_SUM_PUBLISH);
    taskdesc = t9n(TS.NEW_ORDER_SUM_TASKDESC);
    type = t9n(TS.NEW_ORDER_SUM_TYPE);
    teams = t9n(TS.NEW_ORDER_SUM_TEAMS);
    privteam = t9n(TS.NEW_ORDER_SUM_PRIVTEAM);
    tableamount = t9n(TS.NEW_ORDER_SUM_AMOUNT);
    payment = t9n(TS.NEW_ORDER_SUM_PAYMENT);
    price = t9n(TS.NEW_ORDER_SUM_PRICE);
    tablevat = t9n(TS.NEW_ORDER_SUM_VAT);
    total = t9n(TS.NEW_ORDER_SUM_TOTAL);

    tableaddinfo = t9n(TS.NEW_ORDER_LABEL_ADD_INFO);
    tableloc = t9n(TS.NEW_ORDER_HEADER_LOC);
    tabletime = t9n(TS.NEW_ORDER_HEADER_TIME);

    cancel = t9n(TS.PILOT_POINTS_DONATE_CONFIRM_CANCEL_LABEL);
    yes = t9n(TS.TXT_YES);
    btn_prev = t9n(TS.TABLE_BUTTON_PREV);
    btn_publish = t9n(TS.NEW_ORDER_PUBLISH);
    workeremail = t9n(TS.NEW_ORDER_SUM_W_EM);
    distancework = t9n(TS.ORDERS_IS_VIRTUAL);

    table_data[0].left = taskdesc;
    table_data[1].left = type;
    table_data[2].left = tableaddinfo;
    table_data[3].left = teams;
    table_data[4].left = privteam;
    table_data[5].left = tableloc;
    table_data[6].left = tabletime;
    table_data[7].left = tableamount;
    table_data[8].left = payment;
    table_data[9].left = t9n(TS.ORDER_ACC_REF);

    table_data[10].left = price;
    table_data[11].left = tablevat;
    table_data[12].left = total;
    table_data[13].left = workeremail;
    table_data[14].left = t9n(TS.PRODUCT_WORKER_TYPE);

    format_location_string();
  };

  $: if (!!$session && !!sum_task_desc) translate_texts();

  $: if (JSON.parse(window.localStorage.getItem('WP.tutorial.new_order'))) {
    show_tutorial_screen(true, 'new_order_o13', 200, 'orderer');
  }

</script>

<div class="mdc-data-table margin-left-proc-10 fade-in">
  <table class="mdc-data-table__table table-summary">
    <tbody class="mdc-data-table__content">
    {#each table_data as row, i}
      {#if row.right !== null && row.show === true}
        {#if row.right !== ''}
          <tr class="mdc-data-table__row">
            <td style=' font-size: 16px;'
                    class="mdc-data-table__cell font-size-1rem data-heading={row.left}">
              {row.left}
            </td>
            <td style=' font-size: 16px;'
                    class="mdc-data-table__cell mdc-data-table__cell--numeric
                table-wrap">
              {row.right}
            </td>
          </tr>
        {/if}
      {/if}
    {/each}
    {#each additional_fields as row, i}
      {#if !!row.value}
        <tr class="mdc-data-table__row">
          <td style=' font-size: 16px;'
                  class="mdc-data-table__cell font-size-1rem data-heading={row.left}">
            {row.label}
          </td>
          <td style=' font-size: 16px;'
                  class="mdc-data-table__cell mdc-data-table__cell--numeric
              table-wrap">
            {#if row.value === true || row.value === 'true'}
              {t9n(TS.TXT_YES)}
            {:else}{row.value}{/if}

          </td>
        </tr>
      {/if}
    {/each}
    </tbody>
  </table>
</div>

<!-- Back + Next -->
<p />
<div style="display: flex; justify-content: flex-end;">
  <div style="margin-right: 10px;">
    <button
            onclick="prev_tab()"
            class="mdc-button mdc-button--outlined margin-5">
      <span class="mdc-button__ripple" />
      {btn_prev}
    </button>
  </div>

  <button
          id="myDialog"
          on:click|preventDefault={toggle_dialog}
          class="mdc-button mdc-button--unelevated publish margin-5">
    <span class="mdc-button__ripple" />
    {btn_publish}
  </button>
</div>

<div class="switch-dialog" />

<style>
  .mdc-data-table {
    margin-bottom: 50px;
  }

  .mdc-data-table__content {
    background-color: #e0f3ff;
  }

  td:nth-child(2) {
    white-space: pre-wrap;
  }

  .newline {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .table-wrap {
    max-width: 400px;
    word-wrap: break-word;
    white-space: normal;
  }

  /* Desktop Mode
          *******************************************************/
  @media (min-width: 1025px) {
    .mdc-data-table__table {
      min-width: 800px;
    }

    .mdc-data-table {
      margin-left: 80px;
    }
  }

  /* Tablet Mode
          *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .mdc-data-table__table {
      width: 540px !important;
    }

    .mdc-data-table {
      margin-left: 50px;
    }
  }

  /* Mobile Mode
          *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .mdc-data-table__table {
      width: 100% !important;
    }

    .mdc-data-table {
      margin-left: 50px;
    }

    .table-wrap {
      max-width: 100%;
    }

    .mdc-data-table__row {
      /*margin: .25rem 1rem;*/
      padding: 0.5rem 0;
      display: block;
      /*border-bottom: 2px solid #FFC842;*/
    }

    .mdc-data-table__cell {
      display: block;
      height: 100%;
      text-align: center;
      font-weight: bold;
      /*padding: .5rem 0;*/
    }

    .mdc-data-table__cell:before {
      content: attr(data-heading);
      display: inline-block;
      /*width: 5rem;*/
      /*margin-right: .5rem;*/
      /*color: #999;*/
      /*font-size: .75rem;*/
      /*text-transform: uppercase;*/
      /*letter-spacing: 2px;*/
    }

    .mdc-data-table__cell--numeric {
      /*text-align: left;*/
      /*text-transform: capitalize;*/
      font-weight: normal;
    }
  }
</style>
